import { render, staticRenderFns } from "./RegisterHosxp.vue?vue&type=template&id=522e36bb&"
import script from "./RegisterHosxp.vue?vue&type=script&lang=js&"
export * from "./RegisterHosxp.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHosxp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports